// partRoutes.js
import { lazy } from "react";

const AddPart = lazy(() => import("./AddPart"));
const ImportPart = lazy(() => import("./ImportPart"));
const ImportPDIParameters = lazy(() => import("./ImportPDIParameters"));
const ImportWO = lazy(() => import("./ImportWO"));
const PartList = lazy(() => import("./PartList"));
const WorkOrderList = lazy(() => import("./WorkOrderList"));
const DailyOperation = lazy(() => import("./DailyOperation"));
const DailyOperationEmployeeSelect = lazy(() => import("./DailyOperationEmployeeSelect"));
const DailyOperationLogs = lazy(() => import("./DailyOperationLogs"));
const Quality = lazy(() => import("./Quality"));
const Dispatch = lazy(() => import("./Dispatch"));
const InspectionList = lazy(() => import("./InspectionList"));
const ReworkList = lazy(() => import("./ReworkList"));

const partRoutes = [
  { path: "/part/add", element: <AddPart /> },
  { path: "/part/import", element: <ImportPart /> },
  { path: "/part/pdi-parameter-import", element: <ImportPDIParameters /> },
  { path: "/part/work-order-import", element: <ImportWO /> },
  { path: "/part/list", element: <PartList /> },
  { path: "/part/quality", element: <Quality /> },
  { path: "/part/dispatch", element: <Dispatch /> },
  { path: "/part/work-order-list", element: <WorkOrderList /> },
  { path: "/part/daily-operation", element: <DailyOperation /> },
  { path: "/part/daily-operation/select-employee", element: <DailyOperationEmployeeSelect /> },
  { path: "/part/daily-operation-logs", element: <DailyOperationLogs /> },
  { path: "/part/inspection", element: <InspectionList /> },
  { path: "/part/rework", element: <ReworkList /> }
];

export default partRoutes;
